/**
 * 实物商品组合
 */
import { AsyncRequest } from '@/utils/request'
import { getCombinationDetail } from '@/api/modules/goods/physical.js'

const state = {
  userInfo: {},
  goodsArr: [],
  goodsDetail: []
}

const getters = {
  userInfo: state => state.userInfo,
  goodsInfo: state => state.userInfo.goodsInfo,
  goodsDetail: state => state.goodsDetail,
  goodsArr: state => state.goodsArr
}

const mutations = {
  setGoodsDetail: (state, res) => {
    const { goodsInfoList } = res
    // 将渠道信息放到商品里
    goodsInfoList.forEach(item => {
      item.busiType = res.busiType || ''
      item.channelFirst = res.channelFirst || ''
      item.channelSecond = res.channelSecond || ''
      item.joinActivity = res.joinActivity || ''
      item.nickName = res.nickName || ''
      item.termId = res.termId || ''
      item.userId = res.userId || ''
      item.userName = res.userName || ''
      item.checked = false
    })
    state.goodsArr = goodsInfoList
    state.goodsDetail = res
  },
  checkedGood(state, data) {
    const list = state.goodsArr
    if (data.type == 'updata') {
      const index = list.findIndex(item => item.goodsId === data.goodsId)
      delete data.type
      data.stockNum === 0 ? (data.checked = false) : null
      list[index] = { ...list[index], ...data }
    } else {
      const index = list.findIndex(item => item.goodsId === data)
      list[index].checked = !list[index].checked
    }
    state.goodsArr = JSON.parse(JSON.stringify(list))
  }
}

const actions = {
  // 商品详情
  getCombinationDetail({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => getCombinationDetail(payload),
      resolve: res => commit('setGoodsDetail', res)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
